import React from 'react';
import MasterLayout from '../../masterLayout/MasterLayout';
import Breadcrumb from '../../components/Breadcrumb';
import SecteursMapSearch from '../../components/secteurs/SecteursMapSearch';

const SecteursCartePage = () => (
  <MasterLayout>
    <Breadcrumb title="Carte des secteurs" />
    <SecteursMapSearch />
  </MasterLayout>
);

export default SecteursCartePage;
